import React from 'react';
import { Paper } from '@mui/material';
import { StyledTypography, StyledOuterDiv } from './styles';
import { SEGMENT_COLORS } from '../../Constants';

const Legend = () => {
    return (
        <Paper
            component="section"
            role="region"
            aria-label="Map Legend"
            style={{ padding: '10px', display: 'flex', marginRight: "10px" }}
        >
            <div style={{ display: 'flex' }}>

                {/* Texas 100 Monitored Roads Legend */}
                <StyledOuterDiv>
                    <svg width="80" height="20" aria-hidden="true" style={{ marginRight: '10px', flexShrink: 0 }}>
                        <line x1="0" y1="10" x2="80" y2="10" stroke={SEGMENT_COLORS.texas100} strokeWidth="3" strokeDasharray="1 8" strokeLinecap="round" />
                    </svg>
                    <StyledTypography variant="body2">Texas 100 Monitored Roads</StyledTypography>
                </StyledOuterDiv>

                {/* Top 100 Segments Legend */}
                <StyledOuterDiv>
                    <svg width="80" height="20" aria-hidden="true" style={{ marginRight: '10px', flexShrink: 0 }}>
                        <line x1="0" y1="10" x2="80" y2="10" stroke={SEGMENT_COLORS.top100} strokeWidth="3" />
                    </svg>
                    <StyledTypography variant="body2">Top 100 Segments</StyledTypography>
                </StyledOuterDiv>

                {/* Added Roadway Segments Legend */}
                <StyledOuterDiv>
                    <svg width="80" height="20" aria-hidden="true" style={{ marginRight: '10px', flexShrink: 0 }}>
                        <line x1="0" y1="10" x2="80" y2="10" stroke={SEGMENT_COLORS.added} strokeWidth="3" strokeDasharray="8 4" />
                    </svg>
                    <StyledTypography variant="body2">Added Roadway Segments</StyledTypography>
                </StyledOuterDiv>

                {/* Highlighted and Added Roadway Segments Legend */}
                <StyledOuterDiv>
                    <svg width="80" height="20" aria-hidden="true" style={{ marginRight: '10px', flexShrink: 0 }}>
                        <line x1="0" y1="10" x2="80" y2="10" stroke={SEGMENT_COLORS.added} strokeWidth="3" />
                    </svg>
                    <StyledTypography variant="body2">Highlighted Segments(Added)</StyledTypography>
                </StyledOuterDiv>
            </div>
        </Paper>
    );
};

export default Legend;